<script>
  import TaxCalculator from './components/TaxCalculator.svelte';
  import TaxExplanation from './components/TaxExplanation.svelte';
  import { setupI18n, changeLocale, _ } from "../../../../helpers/i18n.js";
  import { globalStore } from "../store/globalStore";
  import { setupPageTracking } from '../../helpers/analytics.js';

  const urlParams = new URLSearchParams(window.location.search);
  const paramCountry = urlParams.get('country') ?? 'cl';

  setupPageTracking('taxes');

  const i18nSetup = setupI18n(paramCountry);

  const { country, isMobile } = globalStore;

  // Reaccionar a cambios en el país del globalStore
  $: if ($country) {
    changeLocale($country);
  }

  $: explanationIcon = $isMobile ? '/icons/explanation_mobile.svg' : '/icons/explanation.svg';
</script>

{#await i18nSetup then}
<div class="calculator-header">
  <div class="calculator-header__wrapper">
    <h1 class="calculator-title">
      {$_("taxes.calculation.title")}
    </h1>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <img src={explanationIcon} alt="Conoce más." title="Conoce más." class="help-icon" on:click={() =>document.getElementById("explanation").scrollIntoView({ behavior: "smooth" })}/>
  </div>
</div>
<div class="main-content">

  <TaxCalculator/>
</div>

<div class="explanation-content" id="explanation">
  <TaxExplanation />
</div>
{/await}
